import { supabase } from '../../supabase';
import { getAccessToken } from '../../utils/authedRequest';

// A photo selection can outlive an anonymous browser session, especially in an
// in-app browser. Restore the guest session before uploading the photos rather
// than sending a large request that the analysis service must reject.
export async function getColourAnalysisToken(isAnonymous) {
  let token = await getAccessToken();
  if (!token && isAnonymous) {
    const { data, error } = await supabase.auth.signInAnonymously();
    if (error) throw new Error('Your session could not be restored. Please reload this page and try again.');
    token = data?.session?.access_token || null;
  }
  if (!token) throw new Error('Your session has expired. Please sign in and try again.');
  return token;
}
